/**
 * A chave carrega o perfil porque a resposta é por conta: sem ele, sair de uma
 * conta da plataforma e entrar em outra serviria `true` do cache e desenharia o
 * item de menu para quem não é (docs/04 §2).
 */
export const platformAccessKeys = {
  all: ['platform-access'] as const,
  /** "Eu sou da plataforma?" — a RPC `is_platform_admin`. */
  admin: (profileId: string) => [...platformAccessKeys.all, 'admin', profileId] as const,
};
